import general from "../general";
import { sortEncodeAndHash } from "./signFunc";

// 搜索链路kid获取
const getKidCallback = async (data = {}) => {
  const time = new Date().getTime().toString();

  let kid = "";
  await general.axios
    .post(
      "/v4/tracking/generate/kid",
      { ...data },
      {
        headers: {
          sign: sortEncodeAndHash({
            ...data,
            timestamp: time,
          }),
          timestamp: time,
        },
      },
    )
    .then((res) => {
      console.log("获取kid进行链路---", res);
      kid = res.data.kid;
    })
    .catch((error) => {
      kid = "";
    });

  return kid;
};

// 多个kid获取公共kid
const getCommonKidCallback = async (data = {}) => {
  const time = new Date().getTime().toString();

  let commonKid = "";
  await general.axios
    .post(
      "/v4/tracking/common/kid/mapping",
      { ...data },
      {
        headers: {
          sign: sortEncodeAndHash({
            ...data,
            timestamp: time,
          }),
          timestamp: time,
        },
      },
    )
    .then((res) => {
      console.log("获取公共kid---", res);
      commonKid = res.data.kid;
    })
    .catch((error) => {
      commonKid = "";
    });

  return commonKid;
};

// 行为上报
const userClickReport = async (objData) => {
  const time = new Date().getTime().toString();

  general.axios
    .post("/v4/tracking/report/search", objData, {
      headers: {
        sign: sortEncodeAndHash({
          ...objData,
          timestamp: time,
        }),
        timestamp: time,
      },
    })
    .then(async (res) => {
      console.log("用户点击上报---", res);
    })
    .catch((error) => console.log("media-point " + error));
};

export { getKidCallback, getCommonKidCallback, userClickReport };
